import Types from "./Types";

export const DeliveryDaySlotsLoading = (payload) => ({
  type: Types.DELIVERY_DAY_SLOTS_LOADING,
  payload,
});

export const GetDeliveryDaySlots = (payload, variables) => ({
  type: Types.GET_DELIVERY_DAY_SLOTS_SUCCESS,
  payload,
  variables,
});

export const UpdateDeliveryDaySlots = (payload) => ({
  type: Types.UPDATE_DELIVERY_DAY_SLOT_SUCCESS,
  payload,
});

export const GetDeliverySlotDays = (payload, variables) => ({
  type: Types.GET_DELIVERY_SLOT_DAYS_SUCCESS,
  payload,
  variables,
});

export const UpdateDeliverySlotDays = (payload) => ({
  type: Types.UPDATE_DELIVERY_SLOT_DAYS_SUCCESS,
  payload,
});
